import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';
import { PostResponseBody } from '../types/api-response';
import { Reply } from '../types/reply';

export type CreateClientQueryReplyRequest = {
    reply: { rawReply: string; structuredReply: { [key: string]: unknown } };
};

async function createClientQueryReply(
    req: CreateClientQueryReplyRequest,
    workpaperId: string,
    clientQueryId: string
): Promise<PostResponseBody<Reply>> {
    const { data } = await api.post(`/workpapers/${workpaperId}/client-queries/${clientQueryId}/replies`, req);
    return data;
}

export function useCreateClientQueryReply(
    workpaperId: string,
    clientQueryId: string
): UseMutationResult<PostResponseBody<Reply>, AxiosError, CreateClientQueryReplyRequest, unknown> {
    return useMutation((req) => createClientQueryReply(req, workpaperId, clientQueryId), {
        onSettled: () => {
            queryClient.invalidateQueries(['worksheets']);
            queryClient.invalidateQueries(['other-schedules']);
            queryClient.invalidateQueries(['workpapers', workpaperId, 'client-queries']);
            queryClient.invalidateQueries(['workpapers', workpaperId, 'client-queries', clientQueryId]);
            queryClient.invalidateQueries([workpaperId, 'trial-balance']);
        },
    });
}
